import { CanDeactivateFn } from '@angular/router';

/** Asks before leaving a page that holds unsaved edits (PLAN 6.3). */
export const unsavedChangesGuard: CanDeactivateFn<{ hasUnsavedChanges(): boolean }> =
  component => !component.hasUnsavedChanges() || confirm('Discard unsaved offering changes?');
